import * as Sentry from '@sentry/browser';

import shouldUseSentry from '../router/utils/shouldUseSentry';

import ExecutionEnvironment from '../ExecuteEnvironment';

import { LOCAL_STORAGE } from './consts';

// TODO - make this file isomorphic
export function getToken() {
  // TODO - improve this
  if (ExecutionEnvironment.isServer) {
    return global.ssr.sessionCookie;
  }

  return localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN);
}

export function isLoggedIn() {
  return !!getToken();
}

export function setToken(token: string) {
  if (ExecutionEnvironment.isServer) {
    return null;
  }

  localStorage.setItem(LOCAL_STORAGE.ACCESS_TOKEN, token);

  if (token) {
    if (shouldUseSentry) {
      Sentry.configureScope((scope) => {
        scope.setUser(null);
      });
    }
  }
}

export function removeToken() {
  if (ExecutionEnvironment.isServer) {
    return null;
  }

  localStorage.removeItem(LOCAL_STORAGE.ACCESS_TOKEN);
}

export function logout() {
  if (ExecutionEnvironment.isServer) {
    return null;
  }

  // remove everything from localstorage except USER && USER_PASS
  Object.keys(LOCAL_STORAGE).map((key) =>
    localStorage.removeItem(LOCAL_STORAGE[key]),
  );
}

export const getDomainName = () => {
  if (ExecutionEnvironment.isServer) {
    return global.ssr.hostname;
  }

  // Used for debug on Staging
  // if (config.FEEDBACK_ENV === 'development') {
  //   const host = window.location.host.split(':')[0];
  //
  //   return host.replace('feedback.local', 'feedback.house');
  // }
  return window.location.hostname;
};
